import { $getUserVehicles } from "@/utils/endpoints";
export const state = () => ({
  userVehicles: [],
});

const getters = {
  userVehicles: (state) => state.userVehicles,
};

const mutations = {
  setUserVehicles: (state, newValue) =>
    (state.userVehicles =
      newValue && newValue.length
        ? newValue.filter(({ active }) => active)
        : []),
};
const actions = {
  getUserVehicles: async ({ commit }, { userId, token }) => {
    commit("setUserVehicles", await $getUserVehicles(userId, token));
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
